import { useEffect, useRef } from 'react';

// Runs `callback` whenever `value` changes (skipping the initial mount). Unlike
// a raw useEffect keyed on the value, the callback is read from a ref so the
// effect's only dependency is `value` — no exhaustive-deps disable needed.
const useValueChangeEffect = (value: any, callback: () => void): void => {
	const previousValue = useRef(value);
	const callbackRef = useRef(callback);
	callbackRef.current = callback;

	useEffect(() => {
		if (previousValue.current === value) {
			return;
		}
		previousValue.current = value;
		callbackRef.current();
	}, [value]);
};

export default useValueChangeEffect;
